import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

/** Fixed operator-wordmark height (px) — reserves space so no shift on load. */
export const WORDMARK_HEIGHT = 60;

export const StyledWordmarkWrapper = styled(Box)({
	marginLeft: '14px',
	marginRight: '14px',
	paddingTop: '8px',
});

export const StyledWordmarkFrame = styled(Box)({
	position: 'relative',
	height: WORDMARK_HEIGHT,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});

export const StyledWordmarkImage = styled('img', {
	shouldForwardProp: (prop) => prop !== 'loaded',
})<{ loaded: boolean }>(({ loaded }) => ({
	position: 'absolute',
	inset: 0,
	width: '100%',
	height: '100%',
	objectFit: 'contain',
	opacity: loaded ? 1 : 0,
	transition: 'opacity 0.2s ease',
}));
